const backLink = document.querySelector('[data-back-link]');

if (backLink) {
  backLink.addEventListener('click', () => {
    history.back();
  });
}
